import { useEffect, useState } from "react";

function diff(deadline) {
  const end = new Date(deadline).getTime();
  const now = Date.now();
  return Math.max(0, end - now);
}

function pad(n) { return String(n).padStart(2, "0"); }

export function Countdown({ deadline, testId, className = "" }) {
  const [ms, setMs] = useState(() => diff(deadline));

  useEffect(() => {
    const id = setInterval(() => setMs(diff(deadline)), 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (ms <= 0) {
    return (
      <span data-testid={testId} className={`font-mono-t font-black text-red-500 ${className}`}>
        SCADUTO
      </span>
    );
  }

  const total = Math.floor(ms / 1000);
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const urgent = ms < 3600 * 1000;

  return (
    <span
      data-testid={testId}
      className={`font-mono-t font-black tabular-nums ${urgent ? "text-red-500" : "text-zinc-950"} ${className}`}
    >
      {d > 0 ? `${d}g ` : ""}{pad(h)}:{pad(m)}:{pad(s)}
    </span>
  );
}
